import { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { EyeFill, Pencil, Plus, Trash } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import Grid, { GridColumn, GridHeader, GridRow } from "../../../components/Grid/Grid";
import WebService from "../../../utility/WebService";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";
import PageTitle from "../../../components/PageTitle/PageTitle";
import routePaths from "../../../Navigation/routePaths";
import HelperService from "../../../utility/HelperService";
import AddExpenseType from "./AddExpenseType";
import { permissionsInterface } from "../../onBoarding/onBoardingTypes";
import { useSelector } from "react-redux";

const headers: GridHeader[] = [
    {
        title: "Name",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "name",
    },
    {
        title: "Date",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "created_at",
    },
    {
        title: "Action",
        class: "text-center freeze-column",
        headerClass: "text-center",
        isSorting: false,
        isFilter: false,
        isFreeze: true,
    },
];

const ExpenseTypePage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const nextOffset = useRef<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [expenseId, setExpenseId] = useState<string>("");
    const [showDeleteModal, setDeleteModal] = useState<boolean>(false);
    const [rows, setRows] = useState<GridRow[]>([]);
    const rowCompute = useRef<GridRow[]>([]);
    const [showHiddenFields, setShowHiddenFields] = useState<boolean>(false);
    const [pressedKeys, setPressedKeys] = useState(new Set());
    const [expenseCount, setExpenseCount] = useState<number>(0);
    const [openAddExpense, setOpenAddExpense] = useState<boolean>(false);
    const [selectedExpense, setSelectedExpense] = useState<any>(null);
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const [permissions, setPermissions] = useState<permissionsInterface | null>(null);

    useEffect(() => {
        if (token && token.token && token.permissions && !!token.permissions.length) {
            setPermissions(token.permissions.find((item: any) => item.name === "EXPENSES"));
        }
    }, [token])

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, [pressedKeys]);

    useEffect(() => {
        showHiddenFields && getExpenseTypeList(1);
    }, [showHiddenFields]);

    const actionList = (data: any) => {
        return (
            <div className="action-btns">
                {permissions && permissions.can_write && !id && <button onClick={() => navigate(routePaths.ADD_EXPENSE_TYPE.path + `/${data.uuid}`)} className="cursor-pointer btn-edit btn">
                    {" "}                    <EyeFill />{" "}View Sub Type                </button>}
                {permissions && permissions.can_update && <button className="cursor-pointer  btn-edit btn" onClick={() => { setSelectedExpense(data); setOpenAddExpense(true) }}>
                    {" "}
                    <Pencil />{" "}
                </button>}
                {permissions && permissions.can_delete && <button
                    onClick={() => onConfirmDelete(data)}
                    className="cursor-pointer btn btn-delete"
                >
                    {" "}
                    <Trash />{" "}
                </button>}
            </div>
        );
    };

    const onConfirmDelete = (val: any) => {
        setExpenseId(val.id);
        setDeleteModal(true);
    };

    const getExpenseTypeList = (
        offset: number,
        keyword?: string,
        startDate?: Date,
        endDate?: Date,
        order_by?: string,
        sort_by?: string
    ) => {
        nextOffset.current = offset;
        if (nextOffset.current < 0 || isLoading) {
            return;
        }
        setIsLoading(true);
        WebService.getAPI({
            action: `expense-type/pagination/list?limit=10&offset=${offset - 1}&keyword=${keyword ? keyword : ""
                }&sort_by=${order_by ?? "asc"}&order_by=${sort_by ?? "created_at"}&from_date=${startDate ? startDate : ""}&to_date=${endDate ? endDate : ""
                }&parent_expense_type_id=${id ? id : ""}`,
            body: null,
            is_session: showHiddenFields
        })
            .then((res: any) => {
                setIsLoading(false);
                let rows: GridRow[] = [];
                setExpenseCount(res.count);
                for (var i in res.list) {
                    let columns: GridColumn[] = [];
                    columns.push({
                        value: res.list[i]?.name ? res.list[i]?.name : "N/A",
                    });
                    columns.push({
                        value:
                            res.list[i].created_at &&
                            HelperService.getFormatedDate(res.list[i].created_at),
                    });
                    columns.push({
                        value: actionList(res.list[i]),
                        type: "COMPONENT",
                    });
                    rowCompute.current.push({ data: columns });
                    rows.push({ data: columns });
                }
                rowCompute.current = rows;
                setRows(rowCompute.current);
            })
            .catch((e) => {
                setIsLoading(false);
            });
    };

    const onSortList = (offset: number, isAscending?: boolean, key?: string) => {
        getExpenseTypeList(
            offset,
            null as any,
            null as any,
            null as any,
            isAscending ? "asc" : "desc",
            key
        );
    };

    const onDelete = () => {
        setDeleteModal(false);
        setIsLoading(true);
        WebService.deleteAPI({
            action: `delete/expense-type/${expenseId}`,
            body: null,
        })
            .then((res: any) => {
                setIsLoading(false);
                toast.success(res.message);
                setExpenseId("");
                getExpenseTypeList(1);
            })
            .catch((e) => {
                setIsLoading(false);
                setExpenseId("");
            });
    };

    const handleKeyDown = (e: any) => {
        const key = e.key.toLowerCase();
        setPressedKeys((prev: any) => new Set([...prev, key]));
    };

    const handleKeyUp = (e: any) => {
        const key = e.key.toLowerCase();
        if (pressedKeys.has('control') && pressedKeys.has('alt') && pressedKeys.has('o') && pressedKeys.has('p')) { setShowHiddenFields(true); }
        setPressedKeys((prev: any) => { const updated = new Set(prev); updated.delete(key); return updated; });
    };

    return (
        <>
            {openAddExpense && <AddExpenseType isShow={openAddExpense} isClose={(e: boolean) => { setOpenAddExpense(false); e && getExpenseTypeList(1) }} data={selectedExpense} />}
            <DeleteModal isShow={showDeleteModal} close={() => { setDeleteModal(false); }} onDelete={() => { onDelete(); }} />
            {permissions && permissions.can_read && <div className="app-page page-dashboard">
                <div className="d-flex justify-content-between align-items-center ">
                    <PageTitle title="Expenses Type" backArrow={true} active={showHiddenFields} />
                    <Button className="btn btn-brand-1 mb-3" onClick={() => { setSelectedExpense(null); setOpenAddExpense(true); }}>
                        {" "}                        <Plus size={20} className="ms-1" /> Add Expense Type
                    </Button>
                </div>
                <div className="table-card" key={id ? id : "all"}>
                    <Grid
                        rows={rows}
                        showSearch={true}
                        headers={headers}
                        showDateFilter={true}
                        onPageChange={getExpenseTypeList}
                        errorMessage={"No Expense Found"}
                        ShowLoader={isLoading}
                        onSort={onSortList}
                        count={expenseCount}
                    />
                </div>
            </div>}
        </>
    );
};

export default ExpenseTypePage;
